import React from "react";
import { CalendarBlockParams } from "./CalendarBlockParams.csharp";
import classNames from "classnames";
import { CalendarBlockLegend } from "./CalendarBlockLegend";
import { CalendarDayEventBlock } from "../CalendarDayEventBlock/CalendarDayEventBlock";
import { CalendarDayEventBlockList } from "../CalendarDayEventBlock/CalendarDayEventBlockList";

export const CalendarBlockFullView: React.FC<CalendarBlockParams> = ({
  title,
  body,
  whiteBackground,
  items,
  subheading,
  notFullAnnotation,
  fullAnnotation,
  useH3SizeTitle,
  hideSubheading,
  hideAnnotations,
}) => {
  return (
    <div
      className={classNames("py-2", {
        "calendar-block__with-borders": whiteBackground,
        "px-2 theme-inherit-light": !whiteBackground,
      })}
    >
      <h2
        className={classNames(
          "calendar-block__full-view-heading pb-2 mb-0",
          { h3: useH3SizeTitle },
          { h4: !useH3SizeTitle }
        )}
      >
        {title}
      </h2>
      <div dangerouslySetInnerHTML={{ __html: body }} />
      {!hideSubheading && (
        <caption className="h4 theme-border pb-1 mb-2">
          {subheading ?? "Timeplan"}
        </caption>
      )}
      {!hideAnnotations && <CalendarBlockLegend size="big" fullAnnotation={fullAnnotation} notFullAnnotation={notFullAnnotation} onWhiteBg={whiteBackground} />}
      <ul className="calendar-block__table">
        {items.map((calendarItemBlock, colIdx) => (
          <li className="calendar-block__table-column" key={colIdx}>
            <h3>{calendarItemBlock.heading}</h3>
            <CalendarDayEventBlockList items={calendarItemBlock.dayEvents} itemsWhiteBg={!whiteBackground} />
          </li>
        ))}
      </ul>
    </div>
  );
};
